
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      import $$ from 'Dom7';
import actions from '../js/actions.js';
import URLS from '../js/Urls.js';
import { translateKey } from 'reword-js';
var today = new Date();
var iterval1;
var iterval2;
today.setHours(0, 0, 0, 0);
var TodayStr = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
var MyDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
export default {
  data: function () {
    return {
      var2: {
        test: 'asd'
      },
      datetoday: "Today",
      loginObject: {},
      UserSpecificApiKey: null,
      DashboardInfo: {}
    };
  },
  methods: {
    openAlert: function () {
      app.f7.dialog.alert('Hello World');
    },
    UpdateGauges: function () {
      var demoGaugeRooms = app.f7.gauge.get('.demo-gauge-rooms');
      var demoGaugeOccupancy = app.f7.gauge.get('.demo-gauge-occupancy');
      demoGaugeRooms.update({
        value: this.DashboardInfo?.AvailableRooms / 100,
        valueText: this.DashboardInfo?.AvailableRooms + "/" + this.DashboardInfo?.TotalRooms
      });
      demoGaugeOccupancy.update({
        value: this.DashboardInfo?.OccupancyPercent / 100,
        valueText: this.DashboardInfo?.OccupancyValue + '%'
      });
    }
  },
  on: {
    tabInit: async function (e, page) {
      var typingTimer;
      var doneTypingInterval = 2000;
      var searchflag = 1;
      let reservations = [];
      var $ = this.$;
      var self = this;
      $$(document).on('click', '#OpenTelegramButton', async function () {
        const url = "https://web.telegram.org/k/#@RoomRackBot";

        if (window.cordova && window.cordova.platformId) {
          const platform = window.cordova.platformId.toLowerCase();

          if (platform === 'android' || platform === 'ios') {
            cordova.InAppBrowser.open(url, '_blank', 'location=yes');
          } else {
            window.open(url, '_blank');
          }
        } else {
          console.error('Cordova or device plugin is not available.');
        }
      });
      $(".searchbar-enable").on("click", async function (e) {
        app.f7.views.main.router.navigate('/search-reservation/', {
          transition: 'f7-dive'
        });
      });
      $$(".input-clear-button.cancbut").on("click", function () {
        $(".searchbar-disable-button.arrowbut").click();
      });
      const loginobject = actions.LoginGetResult();
      const UserSpecificApiKey = loginobject?.PropertiesList?.find(property => property.PropertyName == loginobject?.PropertyName)?.UserSpecificApiKey;
      self.$setState({
        loginObject: loginobject,
        UserSpecificApiKey: UserSpecificApiKey
      });

      if (localStorage.getItem("islogin") == 1) {
        var id = self.loginObject?.PropertyID;
        var obj = {
          PropertyID: id,
          Date: MyDate,
          UserID: self.loginObject?.UserID,
          UserSpecificApiKey: UserSpecificApiKey
        };
        await actions.GetDashboardData(obj, false);
      }

      var Infotemp = actions.GetDashboardinfo();
      self.$setState({
        DashboardInfo: Infotemp
      }); // var iterval1 = setInterval(async function () {
      //   var counter = await actions.GetNotificationsCounter(UserSpecificApiKey);
      //   SetNotifications(counter);
      // }, 10000);

      var iterval2 = setInterval(async function () {
        var id = self.loginObject?.PropertyID;
        var obj = {
          PropertyID: id,
          Date: MyDate,
          UserID: self.loginObject?.UserID,
          UserSpecificApiKey: UserSpecificApiKey
        };
        await actions.GetDashboardData(obj).then(SetData());
      }, 10000);
      $$(document).on('page:beforeout', function (e) {
        // clearInterval(iterval1);
        clearInterval(iterval2);
      });
      $$(document).on('tab:hide', function (e) {
        // clearInterval(iterval1);
        clearInterval(iterval2);
      });

      function SetData() {
        const dashboardInfo = actions.GetDashboardinfo();

        try {
          self.$setState({
            DashboardInfo: dashboardInfo,
            NotificationsCounter: ashboardInfo?.NotificationsCounter
          });
        } catch (exception) {}
      } // function SetNotifications(counter) {
      //   try {
      //     self.$setState({
      //       NotificationsCounter: counter,
      //     });
      //   } catch (exception) { }
      // }


      function FuncRemoveclass() {
        $$('#Todaybtn').removeClass('customUderline');
        $$('#Tomorrowbtn').removeClass('customUderline');
        $$('#DayAfterTomorrowbtn').removeClass('customUderline');
        $$('#Calendarbtn').removeClass('customUderline');
      }

      $$('#NewReservationbtn').on('click', function () {
        app.f7.views.main.router.navigate('/new-reservation-home/');
      }); //Today button

      $$('#Todaybtn').on('click', async () => {
        var MyDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
        FuncRemoveclass();
        $$('#Todaybtn').addClass('customUderline');
        var id = self.loginObject?.PropertyID;
        var obj = {
          PropertyID: id,
          Date: MyDate,
          UserID: self.loginObject?.UserID,
          UserSpecificApiKey: UserSpecificApiKey
        };
        await actions.GetDashboardData(obj);
        self.$setState({
          DashboardInfo: actions.GetDashboardinfo()
        });
        self.UpdateGauges();
      }); //Tomorrow button

      $$('#Tomorrowbtn').on('click', async () => {
        FuncRemoveclass();
        $$('#Tomorrowbtn').addClass('customUderline');
        var nextDay = new Date(today);
        nextDay.setDate(today.getDate() + 1);
        var MyDate = nextDay.getFullYear() + '-' + (nextDay.getMonth() + 1) + '-' + nextDay.getDate();
        var id = self.loginObject?.PropertyID;
        var obj = {
          PropertyID: id,
          Date: MyDate,
          UserSpecificApiKey: UserSpecificApiKey
        };
        await actions.GetDashboardData(obj);
        self.$setState({
          DashboardInfo: actions.GetDashboardinfo()
        });
        self.UpdateGauges();
      });
      var test = 1; //Dayaftertorrow

      $$('#DayAfterTomorrowbtn').on('click', async () => {
        FuncRemoveclass();
        $$('#DayAfterTomorrowbtn').addClass('customUderline');
        var today = new Date();
        var nextDay = new Date(today);
        nextDay.setDate(today.getDate() + 2);
        var MyDate = nextDay.getFullYear() + '-' + (nextDay.getMonth() + 1) + '-' + nextDay.getDate();
        var id = self.loginObject?.PropertyID;
        var obj = {
          PropertyID: id,
          Date: MyDate,
          UserSpecificApiKey: UserSpecificApiKey
        };
        await actions.GetDashboardData(obj);
        self.$setState({
          DashboardInfo: actions.GetDashboardinfo()
        });
        self.UpdateGauges();
      });
      $$('#demo-calendar-modal').on('click', function () {
        FuncRemoveclass();
        $$('.calendaricon').addClass('customUderline');
      });
      var calendarModal = app.f7.calendar.create({
        inputEl: '#demo-calendar-modal',
        openIn: 'customModal',
        value: [new Date()],
        header: true,
        footer: true
      }); //Calendar Evet

      calendarModal.on("close", async () => {
        var CalendarDate = calendarModal.getValue();
        MyDate = CalendarDate[0].getFullYear() + '-' + (CalendarDate[0].getMonth() + 1) + '-' + CalendarDate[0].getDate();
        var caldate = CalendarDate[0].getDate() + "/" + (CalendarDate[0].getMonth() + 1) + '/' + CalendarDate[0].getFullYear();
        var tod = today.getTime();
        var cal = CalendarDate[0].getTime();

        if (today.getTime() == CalendarDate[0].getTime()) {
          caldate = "Today";
        }

        var id = self.loginObject?.PropertyID;
        var obj = {
          PropertyID: id,
          Date: MyDate,
          UserSpecificApiKey: UserSpecificApiKey
        };
        await actions.GetDashboardData(obj);
        self.$setState({
          DashboardInfo: actions.GetDashboardinfo(),
          datetoday: caldate
        });
      });
      var demoGaugeRooms = app.f7.gauge.create({
        el: '.demo-gauge-rooms',
        type: 'circle',
        value: self.DashboardInfo?.AvailableRooms / 100,
        size: 250,
        borderBgColor: '#51565C',
        borderColor: '#7689CB',
        borderWidth: 14,
        valueText: self.DashboardInfo?.AvailableRooms + "/" + self.DashboardInfo?.TotalRooms,
        valueFontSize: 50,
        valueTextColor: 'white',
        labelText: translateKey('AvailableRooms')
      });
      var demoGaugeOccupancy = app.f7.gauge.create({
        el: '.demo-gauge-occupancy',
        type: 'circle',
        value: self.DashboardInfo?.OccupancyPercent / 100,
        size: 95,
        borderBgColor: '#51565C',
        borderColor: '#7689CB',
        borderWidth: 6,
        valueText: self.DashboardInfo?.OccupancyValue + "%",
        valueFontSize: 20,
        valueTextColor: 'black'
      });
      $$('#avail-btn').on('click', () => {
        app.f7.views.main.router.navigate('/main/availabilities/');
      });
    }
  },
  id: '7b5cc38db6',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=dashboard><div class=navbar><div class="navbar-inner color-theme-white"><div class=left><a href=# class="link icon-only panel-open open-side-options-class" data-panel=left><i class="icon f7-icons if-not-md">menu</i> <i class="icon material-icons if-md">menu</i> </a><span id=About-Framework7 style=float:left;position:relative;margin-top:0px;>Dashboard</span></div><div class=right>';
      r += Template7Helpers.if.call(ctx_1, ctx_1.loginobject?.Communicator, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' <a class="link icon-only" href=/communicator/ ><div style="display: flex;position: relative;"><svg xmlns=http://www.w3.org/2000/svg x=0px y=0px width=20 height=20 viewBox="0 0 50 50"><path fill=#030303 d="M 25 4.0625 C 12.414063 4.0625 2.0625 12.925781 2.0625 24 C 2.0625 30.425781 5.625 36.09375 11 39.71875 C 10.992188 39.933594 11 40.265625 10.71875 41.3125 C 10.371094 42.605469 9.683594 44.4375 8.25 46.46875 L 7.21875 47.90625 L 9 47.9375 C 15.175781 47.964844 18.753906 43.90625 19.3125 43.25 C 21.136719 43.65625 23.035156 43.9375 25 43.9375 C 37.582031 43.9375 47.9375 35.074219 47.9375 24 C 47.9375 12.925781 37.582031 4.0625 25 4.0625 Z M 25 5.9375 C 36.714844 5.9375 46.0625 14.089844 46.0625 24 C 46.0625 33.910156 36.714844 42.0625 25 42.0625 C 22.996094 42.0625 21.050781 41.820313 19.21875 41.375 L 18.65625 41.25 L 18.28125 41.71875 C 18.28125 41.71875 15.390625 44.976563 10.78125 45.75 C 11.613281 44.257813 12.246094 42.871094 12.53125 41.8125 C 12.929688 40.332031 12.9375 39.3125 12.9375 39.3125 L 12.9375 38.8125 L 12.5 38.53125 C 7.273438 35.21875 3.9375 29.941406 3.9375 24 C 3.9375 14.089844 13.28125 5.9375 25 5.9375 Z" style="fill: white;"></path></svg> <span class="badge color-red communicator-badge"><span class=alert-notification-number>';
          r += c(ctx_2.DashboardInfo?.CommunicatorCounter, ctx_2);
          r += '</span></span></div></a>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' <a class="link icon-only" href=/notifications/ ><i class="icon material-icons md-only">notifications_none ';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.loginResult?.DisableNotifications, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' <span class="badge color-red communicator-badge"><span class=alert-notification-number>';
          r += c(ctx_2.DashboardInfo?.NotificationsCounter, ctx_2);
          r += ' </span></span>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' </i></a><a class="link icon-only searchbar-enable"><i class="icon f7-icons if-not-md">search</i> <i class="icon material-icons md-only">search</i></a></div></div></div><div class=page-content style="overflow-x: hidden;"><div class=main-info><div class=row style=width:100%><div class=col-100 style="align-items: flex-end;"></div><div class="content progressdiv"><div class=row><div class=col-50><div class="block block-strong text-align-center"><div class="gauge demo-gauge-rooms"></div></div></div><div class=col-50 style="margin-top: auto;margin-bottom: auto;"><div class=block style=padding:0.3rem;>';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.loginResult?.DisableReservationActions, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class="row custombtn"><button id=NewReservationbtn class="col button button-fill button-round color-theme-white black-text"><div class=row><span class=ReservationBtn style="text-transform: capitalize !important;margin:auto;">';
          r += Template7Helpers.t.call(ctx_2, 'newreservation', {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</span></div></button></div>';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '<div class="row custombtn"><button id=NewReservationbtn style="pointer-events: none;opacity:0.6;" class="col button button-fill button-round color-theme-white black-text"><div class=row><span class=ReservationBtn style="text-transform: capitalize !important;margin:auto;">';
          r += Template7Helpers.t.call(ctx_2, 'newreservation', {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</span></div></button></div>';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' ';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.loginResult?.DisableAvailabilities, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class="row custombtn"><button class="col button button-outline button-round color-theme-white"><span class=AvailabilityBtn style="text-transform: capitalize !important;" id=avail-btn>';
          r += Template7Helpers.t.call(ctx_2, 'availability', {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</span></button></div>';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '<div class="row custombtn"><button class="col button button-outline button-round color-theme-white" style="pointer-events: none;opacity:0.6;"><span class=AvailabilityBtn style="text-transform: capitalize !important;" id=avail-btn>';
          r += Template7Helpers.t.call(ctx_2, 'availability', {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</span></button></div>';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div></div><div class="row ARDEBO" style="text-align: center;"><div class=col-33 id=arrivalslens style="display: grid;"><a href=/arrivals-list/ style="color: white;display: grid;"><span class=title>';
      r += Template7Helpers.t.call(ctx_1, 'arrivals', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' </span><span><span class=big-numbers>';
      r += c(ctx_1.DashboardInfo?.ArrivalsCheckins, ctx_1);
      r += '</span>/ ';
      r += c(ctx_1.DashboardInfo?.ArrivalsTotal, ctx_1);
      r += ' </span><span><i class="material-icons lens" style="color: #EC1D27">lens</i></span></a></div><div class=col-33 style="display: grid"><a href=/departures-list/ style="color: white;display: grid;"><span class=title>';
      r += Template7Helpers.t.call(ctx_1, 'departures', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' </span><span><span class=big-numbers>';
      r += c(ctx_1.DashboardInfo?.DeparturesCheckouts, ctx_1);
      r += '</span>/';
      r += c(ctx_1.DashboardInfo?.DeparturesTotal, ctx_1);
      r += ' </span><span><i class="material-icons lens" style="color: #60C394">lens</i></span></a></div><div class=col-33 style="display: grid"><a href=/inhouse-list/ style="color: white;display: grid;"><span class=title>';
      r += Template7Helpers.t.call(ctx_1, 'InHouse', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' </span><span><span class=big-numbers>';
      r += c(ctx_1.DashboardInfo?.InhouseTotal, ctx_1);
      r += '</span>/';
      r += c(ctx_1.DashboardInfo?.TotalRooms, ctx_1);
      r += ' </span><span><i class="material-icons lens" style="color: #D2CD3E">lens</i></span></a></div></div></div></div></div><div class=Moreinfo><div class=row><div class=col-50><div class="card bigcards left"><div class="card-content card-content-padding takis"><span><i class="material-icons lens" style="color: #07D5C0;">lens </i></span><span style="font-size: 13px !important;margin-bottom: 0.5em"><b>In House </b></span><span style=color:#07D5C0>';
      r += c(ctx_1.DashboardInfo?.InHouse, ctx_1);
      r += ' </span><span style="color:#6e6e6e;font-size:12px;margin-bottom: 2em">';
      r += c(ctx_1.DashboardInfo?.InHouseNextDay, ctx_1);
      r += ' (';
      r += Template7Helpers.t.call(ctx_1, 'tomorrow', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ') </span><span class=badge style="background-color: #D9F6F2;color:#007E67;width: 50%;margin-bottom: 2em;margin-top: 13px;">';
      r += c(ctx_1.DashboardInfo?.InHousePercent, ctx_1);
      r += '%</span><div class=progressbar id=progressbar-green data-progress=';
      r += c(ctx_1.DashboardInfo?.InHouseProgressbar, ctx_1);
      r += '><span></span></div></div></div></div><div class=col-50><div class="card bigcards right"><div class="card-content card-content-padding takis"><span><i class="material-icons lens" style="color: #F26C4F;">lens </i></span><span style="font-size: 13px !important;"><b>Total PAX</b></span><div><i class=material-icons>people</i> <span>';
      r += Template7Helpers.t.call(ctx_1, 'adults', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ': </span><span style=color:#F26C4F>';
      r += c(ctx_1.DashboardInfo?.PaxAdults, ctx_1);
      r += '</span></div><span style="color:#6e6e6e;font-size:12px;margin-bottom: 0.5em">';
      r += c(ctx_1.DashboardInfo?.PaxAdultsNextDay, ctx_1);
      r += '(';
      r += Template7Helpers.t.call(ctx_1, 'tomorrow', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ')</span><div><i class=material-icons>person</i> <span>Child: </span><span style=color:#F26C4F>';
      r += c(ctx_1.DashboardInfo?.PaxChilds, ctx_1);
      r += '</span></div><span style="color:#6e6e6e;font-size:12px;margin-bottom: 2em">';
      r += c(ctx_1.DashboardInfo?.PaxChildsNextDay, ctx_1);
      r += ' (';
      r += Template7Helpers.t.call(ctx_1, 'tomorrow', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ')</span><div class=progressbar id=progressbar-orange data-progress=20><span></span></div></div></div></div></div><div class=row><div class=col-50><div class="card bigcards left"><div class="card-content card-content-padding takis"><span><i class="material-icons lens" style="color: #0077CA;margin-bottom: 1em">lens </i></span><span style="font-size: 13px !important;margin-bottom: 0.5em"><b>Occupancy </b></span><span style="margin: 0.2rem;" class="gauge demo-gauge-occupancy"></span><div class=progressbar id=progressbar-blue data-progress=';
      r += c(ctx_1.DashboardInfo?.OccupancyPercent, ctx_1);
      r += '><span></span></div></div></div></div><div class=col-50><div class="card bigcards right"><div class="card-content card-content-padding takis"><span><i class="material-icons lens" style="color: #07D5C0;margin-bottom: 1em">lens </i></span><span style="font-size: 13px !important;margin-bottom: 0.5em"><b>';
      r += Template7Helpers.t.call(ctx_1, 'AverageStay', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' </b></span><span style=color:#07D5C0>';
      r += c(ctx_1.DashboardInfo?.AverageStayLength, ctx_1);
      r += ' ';
      r += Template7Helpers.t.call(ctx_1, 'nights', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' </span><span style="color:#6e6e6e;font-size:12px;margin-bottom: 2em">';
      r += c(ctx_1.DashboardInfo?.AverageStayLengthNextDay, ctx_1);
      r += ' ';
      r += Template7Helpers.t.call(ctx_1, 'nights', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' (';
      r += Template7Helpers.t.call(ctx_1, 'tomorrow', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ') </span><span class=badge style="background-color: #D9F6F2;color:#007E67;width: 50%;margin-bottom: 2em">';
      r += c(ctx_1.DashboardInfo?.AverageStayLengthPercent, ctx_1);
      r += ' %</span><div class=progressbar id=progressbar-green data-progress=';
      r += c(ctx_1.DashboardInfo?.AverageStayLengthProgressbar, ctx_1);
      r += '><span></span></div></div></div></div></div><div class=row><div class=col-50><div class="card bigcards left"><div class="card-content card-content-padding takis"><span><i class="material-icons lens" style="color: #07D5C0;margin-bottom: 1em">lens </i></span><span style="font-size: 13px !important;margin-bottom: 0.5em"><b>';
      r += Template7Helpers.t.call(ctx_1, 'AverageDailyRate', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' </b></span><span style=color:#07D5C0>';
      r += c(ctx_1.loginResult?.Currency, ctx_1);
      r += ' ';
      r += c(ctx_1.DashboardInfo?.AverageDailyRate, ctx_1);
      r += ' </span><span style="color:#6e6e6e;font-size:12px;margin-bottom: 2em">';
      r += c(ctx_1.loginResult?.Currency, ctx_1);
      r += ' ';
      r += c(ctx_1.DashboardInfo?.AverageDailyRateNextDay, ctx_1);
      r += ' (Yesterday) </span><span class=badge style="background-color: #D9F6F2;color:#007E67;width: 50%;margin-bottom: 2em">';
      r += c(ctx_1.DashboardInfo?.AverageDailyRatePercent, ctx_1);
      r += ' %</span><div class=progressbar id=progressbar-green data-progress=';
      r += c(ctx_1.DashboardInfo?.AverageDailyRateProgressbar, ctx_1);
      r += '><span></span></div></div></div></div><div class=col-50><div class="card bigcards right"><div class="card-content card-content-padding takis"><span><i class="material-icons lens" style="color: #F26C4F;margin-bottom: 1em">lens </i></span><span style="font-size: 13px !important;margin-bottom: 0.5em"><b>';
      r += Template7Helpers.t.call(ctx_1, 'TotalRevenue', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' </b></span><span style=color:#F26C4F>';
      r += c(ctx_1.loginResult?.Currency, ctx_1);
      r += ' ';
      r += c(ctx_1.DashboardInfo?.TotalRevenue, ctx_1);
      r += ' </span><span class=badge style="background-color: #FEF0E7;color:#F26C4F;width: 50%;margin-bottom: 2em">';
      r += c(ctx_1.DashboardInfo?.TotalRevenuePercent, ctx_1);
      r += ' %</span><div class=progressbar id=progressbar-orange data-progress=';
      r += c(ctx_1.DashboardInfo?.TotalRevenuePercent, ctx_1);
      r += '><span></span></div></div></div></div></div><div class="accordion-item accordion-item-opened"><div class="accordion-item-toggle Dashboard" style="margin: 0;padding: 15px;"><div class=row><div class=col-70>Inventory Statistics</div><div class=col-10></div><div class=col-20 style="display: flex; justify-content:flex-end;"><span style="text-align: right"><i class=material-icons>keyboard_arrow_down</i></span></div></div></div><div class=accordion-item-content>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.DashboardInfo?.InventoryStatsList, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class=row><div class=card><div class="card-content card-content-padding takis"><div class=row><div class=col-40>';
          r += c(ctx_2.RoomLabel, ctx_2);
          r += '</div><div class="progressbar col-50" id=progressbar-grey data-progress=';
          r += c(ctx_2.Progressbar, ctx_2);
          r += '><span></span></div><div class=col-10>';
          r += c(ctx_2.Value, ctx_2);
          r += '</div></div></div></div></div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div></div></div></div>';
      return r;
    }(this);
  },

  style: `
  .communicator-badge {
    border-radius: 10px !important;
    position: absolute !important;
    top: -8px !important;
    /* right: -8px; */
    font-size: 11px;
    height: 20px;
    min-width: 20px;
    margin-left: -8px !important;
  }
`,
  styleScoped: false
};
    